import React from 'react'
import {TextField as TF, TextFieldProps} from "@material-ui/core";

export const TextField = ({style, ...props}: TextFieldProps) => (
    <TF {...props} color="primary"  style={{...style}} />
);